var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5998 16.7C32.5998 25.4 25.3698 32.63 16.7298 32.63C10.9098 32.63 5.7898 29.37 4.1898 26.74V49.07H0.799805V0.699951H4.1898V6.64995C5.7898 4.02995 10.9098 0.829951 16.7298 0.829951C25.3698 0.829951 32.5998 8.05995 32.5998 16.7ZM29.2098 16.7C29.2098 9.71995 23.7098 4.21995 16.7298 4.21995C9.74981 4.21995 4.1898 9.71995 4.1898 16.7C4.1898 23.68 9.68981 29.18 16.7298 29.18C23.7698 29.18 29.2098 23.68 29.2098 16.7Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerP);
export default __webpack_public_path__ + "static/media/LOWER_P.86b541676471e66d345069f68f53ba5b.svg";
export { ForwardRef as ReactComponent };